import EventsCta from "../eventsExperiences/EventsCta";
// Placeholder photo until a final AI-content image is ready.
import ctaImage from "../../assets/images/whatwedo/contentCreation.jpg";

const POINTS = [
  "A concept and script outline for your idea",
  "A recommended mix of formats and languages",
  "A clear quote and delivery timeline",
];

// Same call-to-action as the other service pages; the button goes to Contact Us.
const AiCta = () => (
  <EventsCta
    image={ctaImage}
    eyebrow="Start a project"
    title="Got a campaign to promote?"
    accent="Send us the brief."
    intro="Share your goal and budget range. Within 24 hours our team replies with:"
    points={POINTS}
  />
);

export default AiCta;
